module.exports = __webpack_public_path__ + "static/media/ContentCloudIcon.9ddc268a.png";